import { render, staticRenderFns } from "./IndexReminder.vue?vue&type=template&id=6a5513af&scoped=true&"
import script from "./IndexReminder.vue?vue&type=script&lang=js&"
export * from "./IndexReminder.vue?vue&type=script&lang=js&"
import style0 from "./IndexReminder.vue?vue&type=style&index=0&id=6a5513af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5513af",
  null
  
)

export default component.exports